class SocialMediaInspirationCard extends HTMLElement {
  connectedCallback() {
    this.mobileVideo = this.querySelector('video.mobile-video');
    this.desktopVideo = this.querySelector('video.desktop-video');
    this.mobileVideoButton = this.querySelector('button.mobile-video-button');
    this.desktopVideoButton = this.querySelector('button.desktop-video-button');

    this.videos = [this.mobileVideo, this.desktopVideo];
    this.playButtons = [this.mobileVideoButton, this.desktopVideoButton];

    this.debouncedOnResize = debounce(this.handleResize.bind(this), 300);
    this.playButtons.forEach((button) => {
      button?.addEventListener('click', this.handleClick.bind(this));
    });

    this.currentSize = window.innerWidth > 768 ? 'desktop' : 'mobile';

    if ((this.videos[0] && this.playButtons[0]) || (this.videos[1] && this.playButtons[1])) {
      window.addEventListener('resize', this.debouncedOnResize, { passive: true });
    }
  }

  disconnectedCallback() {
    if ((this.videos[0] && this.playButtons[0]) || (this.videos[1] && this.playButtons[1])) {
      window.removeEventListener('resize', this.debouncedOnResize, { passive: true });
    }
  }

  handleClick(event) {
    const controls = event.target.getAttribute('aria-controls');
    const video = this.videos.find((video) => video.id === controls);
    if (!video) return;

    this.toggleVideo(video);
    this.updateButton(event.target);
  }

  toggleVideo(videoElement) {
    videoElement.paused ? videoElement.play() : videoElement.pause();
  }

  updateButton(buttonElement) {
    const currentAriaLabel = buttonElement.getAttribute('aria-label');
    const oppositeLabel = buttonElement.getAttribute('data-opposite-label');

    buttonElement.setAttribute('aria-label', oppositeLabel);
    buttonElement.setAttribute('data-opposite-label', currentAriaLabel);
    buttonElement.querySelector('.play-icon')?.classList.toggle('hidden');
    buttonElement.querySelector('.pause-icon')?.classList.toggle('hidden');
  }

  handleResize() {
    const newSize = window.innerWidth > 768 ? 'desktop' : 'mobile';
    if (newSize === this.currentSize) return;
    this.currentSize = newSize;

    const oldSizeVideo = newSize === 'desktop' ? this.mobileVideo : this.desktopVideo;
    if (!oldSizeVideo || oldSizeVideo.paused) return;

    oldSizeVideo.pause();
    oldSizeVideo.currentTime = 0;
    const oldSizeButton = newSize === 'desktop' ? this.mobileVideoButton : this.desktopVideoButton;
    this.updateButton(oldSizeButton);
  }
}

if (!customElements.get('social-media-inspiration-card')) {
  customElements.define('social-media-inspiration-card', SocialMediaInspirationCard);
}
